const errorSeparator = '^^'

export function parseError (error) {
  let message = getErrorMessage(error)
  const errorData = message.split(errorSeparator)
  let params = {}
  if (errorData.length > 1) {
    message = errorData[0]
    params.errorData = errorData[1]
  }
  if (error.details) {
    params = error.details
  }
  return {
    message,
    params
  }
}

function getErrorMessage (error) {
  if (typeof error !== 'object') {
    return error
  }

  if (error.body && error.body.error) {
    return error.body.error
  }

  if (error.data && error.data.error) {
    return error.data.error
  }

  if (error.message) {
    return error.message
  }

  if (error.error) {
    return error.error
  }

  return error
}



// WEBPACK FOOTER //
// ./src/error/parser.js